const { littlefoot } = require('littlefoot');

export function initLittlefoot() {
    if (window.lf) {
        window.lf.unmount();
        window.lf = null;
    }
    window.lf = littlefoot({
        activateOnHover: true,
        hoverDelay: 0,
        dismissOnUnhover: true,
        dismissDelay: 0,
        buttonTemplate: `
            <button
                aria-label="Footnote <% number %>"
                class="littlefoot__button"
                id="<% reference %>"
                title="See Footnote <% number %>"
            />
                ?
            </button>
        `
    });
}